export const couponsTable = () => {
  const couponsTable = document.querySelectorAll('.coupons-table')
  if (couponsTable) {
    couponsTable.forEach((couponTable) => {
      const coupons = couponTable.querySelectorAll('[data-coupon]')
      if (coupons.length > 10) {
        const baseCoupons = Array.from(coupons).slice(0, 10)
        coupons.forEach((coupon) => {
          if (!baseCoupons.includes(coupon)) {
            coupon.classList.add('d-none')
          }
        })
      }

      const seeMore = couponTable.querySelector('.more span')
      if (seeMore) {
        seeMore.addEventListener('click', () => {
          seeMore.parentElement.classList.add('d-none')
          coupons.forEach((coupon) => {
            coupon.classList.remove('d-none')
          })
        })
      }
    })
  }
}
